
import { computed, defineComponent } from 'vue'
import { useSessionModule } from '@/modules/session'
import AuditLogOperatorActivities from '@/components/employees-audit-log/operator-activities.vue'

export default defineComponent({
    name: 'view-session-profile',
    components: { AuditLogOperatorActivities },
    setup () {
        const { profile, loadProfile, activities } = useSessionModule()
        loadProfile()
        return {
            profile,
            activities: computed(() => activities.value)
        }
    }
})
